<template lang="pug">
  #ChallengeFreeText.is-flex.is-flex-direction-column
    BField
      BInput#welcomeCardText(
        name="free text"
        type="textarea"
        maxlength="320"
        placeholder="Add your free text here..."
        v-model="freeText"
        :disabled="isCompleted"
      )
    br
    WtButton(
      bold
      @click.native="submit"
      :disabled="disableSave"
    ) {{updateFreeText ? 'Update' : 'Submit'}}
</template>

<script>
import WtButton from "@@/WtButton/WtButton";
import { mapActions } from "vuex";

export default {
  name: "ChallengeFreeText",

  components: { WtButton },

  props: {
    challenge: {
      type: Object,
      default: () => {}
    },
    isCompleted: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      freeText: this.challenge.freeText ? this.challenge.freeText : ""
    };
  },

  computed: {
    initialFreeText() {
      return this.challenge.freeText;
    },

    updateFreeText() {
      return !!this.initialFreeText;
    },

    disableSave() {
      if (this.isCompleted) {
        return true;
      }
      return !this.freeText || this.initialFreeText === this.freeText;
    }
  },

  methods: {
    ...mapActions("members", ["mobileAddFreeTextForPreventativeChallenge"]),
    ...mapActions("challenges", ["updateStateForMobileChallenge"]),
    ...mapActions(["snackBar"]),

    async submit() {
      if (this.freeText) {
        try {
          let payload = {
            mobileToken: this.$route.params.mobileToken,
            challengeId: this.challenge.id,
            freeText: this.freeText
          };
          let response = await this.mobileAddFreeTextForPreventativeChallenge(
            payload
          );
          if (!this.updateFreeText) {
            this.snackBar({ message: "Your free text was saved." });
          } else {
            this.snackBar({ message: "Your free text was updated." });
          }
          this.updateStateForMobileChallenge(response);
        } catch (e) {
          let errorMessage =
            this._.get(e, "data.error.message", null) || e.statusText;
          this.completionDate = this.initialDate;
          this.snackBar({
            duration: 5000,
            type: "is-danger",
            message: errorMessage
          });
        }
      }
    }
  }
};
</script>

<style lang="sass" scoped></style>
